import { createAsyncThunk } from '@reduxjs/toolkit';
import { GlobalState } from '../../../types.global';

export const fetchSurvey = createAsyncThunk(
  'surveys/fetchSurvey',
  (data, thunkAPI) => {
    const state = thunkAPI.getState() as GlobalState;
    const { userId, ntpVisitCounter } = state.user;

    const defaultResult = { list: [], fetchedAt: Date.now(), ntpVisitCounter };

    const query = new URLSearchParams({ userId });
    return fetch(`${process.env.APP_URL}/api/surveys?${query}`)
      .then(async (res) => {
        if (res.status !== 200) return defaultResult;

        const json = await res.json();
        return {
          ...json,
          list: json.list || [],
          fetchedAt: Date.now(),
          ntpVisitCounter,
        };
      })
      .catch((err) => {
        console.error('Survey', err);
        return defaultResult;
      });
  }
);
